var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.iconsLoaded)?_c('TripsComponent',{attrs:{"trips":_vm.pastTrips,"title":'Past Trips',"type":'past'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }